// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3AMUB","label":"CategoryService_label__31k4y","location":"CategoryService_location__1IC0x"};